import React from 'react'
import { AppContainer } from '../../layout'
import './Page.css'

const Page = props => {
  const classNames = ["Page"]

  if (props.name) classNames.push(`Page-${props.name}`)
  if (props.theme) classNames.push(`has-theme-${props.theme}`)

  return (
    <div className={classNames.join(' ')} style={props.style}>
      {props.container ? (
        <AppContainer>
          {props.children}
        </AppContainer>
      ) : (
          props.children
        )}
    </div>
  )
}

const PageHeader = props => (
  <div className="Page-header">
    {props.children}
  </div>
)

const PageTitle = props => (
  <div className="Page-title">
    <PageWrapper>
      {props.children}
    </PageWrapper>
  </div>
)

const PageContent = props => (
  <PageWrapper>
    <div className={`Page-content ${props.className || ''} ${props.nospacing ? 'has-no-spacing' : ''}`}>
      {props.children}
    </div>
  </PageWrapper>
)

const PageFooter = props => (
  <PageWrapper>
    <div className="Page-footer" style={props.style}>
      {props.children}
    </div>
  </PageWrapper>
)

const PageWrapper = props => (
  <div className="Page-wrapper">
    {props.children}
  </div>
)

export default Page
export {
  PageContent,
  PageHeader,
  PageFooter,
  PageTitle
}
